import { AsyncPipe } from '@angular/common'
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { User } from '@ftr/contracts/api/user'
import {
  DestroySubscribers,
  IconComponent,
  ScreenSize,
  ScreenSizeService,
  isMobileScreenSize,
  unwrapData,
} from '@ftr/foundation'
import { UserAvatarComponent, UserState } from '@ftr/ui-user'
import { NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngxs/store'
import { Options } from '@popperjs/core'
import { Observable, takeUntil } from 'rxjs'
import { PersonalMenuComponent } from '~app/features/personal-menu/personal-menu.component'

@Component({
  selector: 'ftr-account-dropdown',
  templateUrl: './account-dropdown.component.html',
  styleUrls: ['./account-dropdown.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [PersonalMenuComponent, NgbPopoverModule, IconComponent, UserAvatarComponent, AsyncPipe],
})
export class AccountDropdownComponent extends DestroySubscribers implements OnInit {
  user$: Observable<User>

  protected readonly popperOptions = (options: Partial<Options>): Partial<Options> => {
    // Use default options for desktop
    if (!isMobileScreenSize(this.currentScreenSize)) {
      return options
    }
    // Prevents bad scroll behavior on mobile
    options.modifiers = [
      {
        name: 'computeStyles',
        enabled: false,
      },
    ]
    return options
  }

  @ViewChild(NgbPopover)
  private personalMenuTemplate: NgbPopover

  private currentScreenSize: ScreenSize

  constructor(
    private readonly store: Store,
    private screenSizeService: ScreenSizeService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.user$ = this.store.select(UserState.user).pipe(unwrapData())
    this.watchScreenSize()
  }

  private watchScreenSize(): void {
    this.screenSizeService.size.pipe(takeUntil(this.finalize)).subscribe(size => {
      const shouldReopen = !!this.personalMenuTemplate?.isOpen() && this.currentScreenSize !== size
      this.currentScreenSize = size
      // Popper modifiers/styles aren't dynamic, that's why we close the popover when
      // resizing to and from isMobile for a smoother experience
      if (shouldReopen) {
        this.personalMenuTemplate.close()
        this.personalMenuTemplate.open()
      }
    })
  }
}
